import { useSelector } from 'react-redux'
import { selectActiveLanguage } from '@/store/app'

const useActiveLanguage = () => {
  const language = useSelector(selectActiveLanguage())
  return language
}

export default useActiveLanguage
